import React from "react";
import { Nav, Form, Row, Col, Card, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import "../../assets/scss/page/_editprofile.scss";
import { validationSchema } from "./EditProfileValidationPage";

import { updateUserData } from "../../store/features/authSlice";
import { TNButton } from "../../common/components/TNButton";
import { confirmAlert } from "react-confirm-alert";
import { useGetProfile, useUpdateProfile } from "../../hooks";
const EditProfilePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  /**
   * This api call will gives response of user profile and setting data
   */
  const { refetch: doGetProfile, isLoading } = useGetProfile(
    ({ data: profile }) => {
      console.log(profile);
      if (profile) {
        formik.values.name = profile.name;
        formik.values.email = profile.email;
        formik.values.password = profile.password;
      }
      const dataStore = {
        userData: profile,
      };
      dispatch(updateUserData(dataStore));
    }
  );
  /**
   * This api will call on update button, and will update data
   */
  const { mutate: doUseUpdateProfile } = useUpdateProfile((response) => {
    toast.success(response.message);
    doGetProfile();
    navigate(`/dashboard/`);
  });

  /**
   * This Block is execute on Form Submit for validation
   */
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      doUseUpdateProfile(values);
    },
  });

  /**
   * This function will call when admin clicks on cancel button,
   * and will display alert
   */
  const handleCancel = () => {
    if (formik.dirty && formik.dirty !== undefined) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="alert-box">
              <FontAwesomeIcon
                className="alert-close"
                icon={faClose}
                onClick={() => {
                  onClose();
                }}
              />
              <div className="alert-popup">
                <h2
                  dangerouslySetInnerHTML={{
                    __html: "Are You Sure Want to Cancel ?",
                  }}
                ></h2>
                <Button
                  className="table-delete-button"
                  onClick={() => {
                    onClose();
                    navigate(`/dashboard/`);
                  }}
                >
                  Yes
                </Button>
                <Button className="table-primary-button" onClick={onClose}>
                  No
                </Button>
              </div>
            </div>
          );
        },
      });
    } else {
      navigate(`/dashboard/`);
    }
  };

  return (
    <>
      <Nav className="tab-navigation">
        <Nav.Item>
          <NavLink to="/edit-profile">Edit Profile</NavLink>
        </Nav.Item>
      </Nav>
      <Card className="inner-box">
        <h1 className="page-heading-center">Edit Profile</h1>
        <div className="edit-profile-form">
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col lg={6} md={6} xs={12}>
                <Form.Group>
                  <Form.Label className="field-label field-label-top">
                    Name :-
                  </Form.Label>
                  <Form.Control
                    className={
                      "form-field " +
                      (formik.touched.name && formik.errors.name
                        ? "form-field-error"
                        : formik.touched.name && !formik.errors.name
                        ? "form-field-success"
                        : "")
                    }
                    type="text"
                    name="name"
                    placeholder={"Enter Name"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                  />
                  <div className="form-field-error-text">
                    {formik.touched.name && formik.errors.name ? (
                      <div>{formik.errors.name}</div>
                    ) : null}
                  </div>
                </Form.Group>
              </Col>
              <Col lg={6} md={6} xs={12}>
                <Form.Group>
                  <Form.Label className="field-label field-label-top">
                    Email :-
                  </Form.Label>
                  <Form.Control
                    className={
                      "form-field " +
                      (formik.touched.email && formik.errors.email
                        ? "form-field-error"
                        : formik.touched.email && !formik.errors.email
                        ? "form-field-success"
                        : "")
                    }
                    type="text"
                    name="email"
                    placeholder={"Enter Email"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  <div className="form-field-error-text">
                    {formik.touched.email && formik.errors.email ? (
                      <div>{formik.errors.email}</div>
                    ) : null}
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6} md={6} xs={12}>
                <Form.Group>
                  <Form.Label className="field-label field-label-top">
                    Password :-
                  </Form.Label>
                  <Form.Control
                    className={
                      "form-field " +
                      (formik.touched.password && formik.errors.password
                        ? "form-field-error"
                        : formik.touched.password && !formik.errors.password
                        ? "form-field-success"
                        : "")
                    }
                    type="text"
                    name="password"
                    placeholder={"Enter password"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <div className="form-field-error-text">
                    {formik.touched.password && formik.errors.password ? (
                      <div>{formik.errors.password}</div>
                    ) : null}
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <div className="primary-button">
              <span className="link-center" onClick={handleCancel}>
                Cancel
              </span>
              <TNButton loading={isLoading} type="submit">
                Save
              </TNButton>
            </div>
          </Form>
        </div>
      </Card>
    </>
  );
};

export { EditProfilePage };
